import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function StepsAPI(): BringozApi {
  return {
    base: `/fulfillmentStep`,
    infiniteScroll: {
      address: `/fulfillmentStep`,
      cmd: 'POST'
    },
    actions: {
      getStepsByQuery: {
        address: '',
        cmd: 'POST',
        updateable: false
      },
      createTrainVoucher: {
        address: 'dispatchConsolidate',
        cmd: 'POST',
        updateable: false
      },
      manualHandleAttempt: {
        address: 'manualHandle',
        cmd: 'POST',
        updateable: true
      },
      cancelAttempt: {
        address: 'cancel',
        cmd: 'POST',
        updateable: true
      },
      cancel: {
        address: 'cancelBulk',
        cmd: 'POST',
        updateable: true
      },
      getGlobalSearch: {
        address: 'search',
        cmd: 'GET',
        updateable: false
      },
      getFulfillmentStepSettings: {
        address: 'querySettings',
        cmd: 'POST',
        updateable: false
      }
    }
  }
}

angular
  .module('bringoz.admin.fulfillment')
  .factory('StepsAPI', StepsAPI);
